export default __webpack_public_path__ + "static/media/rock.c16f76b6.svg";